import {styled} from "@mui/material/styles";
import {Box, DialogActions, Grid, TextField, Typography} from "@mui/material";

export const CorrectionModal = styled(Box)(({theme}) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth:'40em',
  width: '100%',
  backgroundColor: theme.palette.background.paper,
  borderRadius: '0.5em',
}));

export const CorrectionHeaderCol = styled(Grid)(() => ({
  width: "30%",
  marginTop: "2em"
}));

export const CorrectionDisplayContainer = styled(Grid)(() => ({
  width: "100%",
}));

export const CorrectionTextField = styled(TextField)(({theme}) => ({
  marginTop: '1.5em',
  '& label': {
    color: theme.palette.primary.main,
    fontWeight: '500',
  },
  '& input::placeholder': {
    fontSize: '1em',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  '& p': {
    color: theme.palette.error.main,
    fontSize: '0.75em',
  }
}));

export const CorrectionBtnGroup = styled(DialogActions)(({theme}) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: '0.3em',
  backgroundColor: theme.palette.grey[100],
  padding: '0.5em 1em',
}));

export const CorrectionReason = styled(Typography)(() => ({
  fontSize: "1.15em",
  fontWeight: "600"
}));
